import React from "react";
import SkeletonCard from "./SkeletonCard";
import SkeletonText from "./SkeletonText";
import SkeletonButton from "./SkeletonButton";

const SkeletonFilters = ({ filterCount = 4, className = "" }) => {
  return (
    <SkeletonCard className={className} showHeader headerTitle>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {Array.from({ length: filterCount }).map((_, index) => (
          <div key={index} className="space-y-2">
            <SkeletonText size="sm" width="20" />
            <SkeletonButton size="md" width="full" />
          </div>
        ))}
      </div>
    </SkeletonCard>
  );
};

export default SkeletonFilters;
